import styles from './VarItemCorrect.module.css';
import { motion } from 'framer-motion';

const VarItemCorrect = ({
  item,
  i,
  answerFontSize,
  varNumFontSize,
  isQuestionImg,
}) => {
  return (
    <div
      className={styles.varCorrect}
      style={{ minHeight: isQuestionImg ? 'none' : '20rem' }}>
      <div
        className={styles.varNumberCorrect}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.55 * varNumFontSize}rem`,
          minWidth: `${1.55 * varNumFontSize}rem`,
        }}>
        {i + 1}
      </div>
      <motion.div
        initial={{
          color: '#001e38',
          backgroundColor: '#fff',
          borderColor: 'transparent',
          boxShadow: '0 0 3rem 0.5rem transparent',
          scale: 1,
        }}
        animate={{
          color: '#fff',
          backgroundColor: '#28af60',
          borderColor: '#fff',
          boxShadow: '0 0 3rem 0.5rem #00ff19',
          scale: [1, 1.1, 1],
        }}
        transition={{
          times: [0, 0.5, 1],
          duration: 0.7,
          delay: 1,
        }}
        className={styles.varTitleCorrect}
        style={{
          fontSize: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '78rem' : '47.92rem',
        }}>
        {item.comment}
      </motion.div>
    </div>
  );
};

export default VarItemCorrect;
